// Plugin propio para manejo de token fcm push

import axios from 'axios'
import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported as isMessagingSupported, onMessage } from 'firebase/messaging';

// FIREBASE WEB APP

export default {

  messaging: null, //futuro objeto messaging
  app: null, // Firebase app instance

  firebaseConfig: {
    apiKey: process.env.MIX_FIREBASE_WEBAPP_API_KEY || "AIzaSyAtDCP1j_eWwkkxWrWKpE0mGpRt5uTej1I",
    authDomain: process.env.MIX_FIREBASE_WEBAPP_AUTH_DOMAIN || "epc-tracker-mobile.firebaseapp.com",
    databaseURL: process.env.MIX_FIREBASE_WEBAPP_DATABASE_URL || "https://epc-tracker-mobile.firebaseio.com",
    projectId: process.env.MIX_FIREBASE_WEBAPP_PROJECT_ID || "epc-tracker-mobile",
    storageBucket: process.env.MIX_FIREBASE_WEBAPP_STORAGE_BUCKET ||  "epc-tracker-mobile.appspot.com",
    messagingSenderId: process.env.MIX_FIREBASE_WEBAPP_MESSAGING_SENDER_ID ||  "813152257413",
    appId: process.env.MIX_FIREBASE_WEBAPP_APP_ID ||  "1:813152257413:web:3df8475afa3d81685ff0ec",
    measurementId: process.env.MIX_FIREBASE_WEBAPP_MEASUREMENT_ID ||  "G-FW2MLJ6ZHN"
  },

  initialize: function() {

    if (this.messaging === null ) {
      // Initialize Firebase
      this.app = initializeApp(this.firebaseConfig); 
        
      this.messaging = getMessaging(this.app);
    }
  },

  // comprueba si navegador soporta firebase messaging (en este momento safari no)
  isSupported: function() {
    return isMessagingSupported()
  },

  // Configura el listener para mensajes en primer plano
  onMessage: function(callback) {
    if (this.messaging) {
      onMessage(this.messaging, callback);
    }
  },

  // llamada tras loguear para registrar el token en Devices como dispositivo tipo web
  registerFCMWebToken: function(data) {

    if (! this.isSupported()) {
      return 0;
    }

    if (Notification.permission == 'granted') {
  
      this.initialize();
  
      // Import getToken dynamically to avoid issues with service worker
      import('firebase/messaging').then(({ getToken }) => {
        getToken(this.messaging, {
          vapidKey: process.env.MIX_FIREBASE_VAPID_KEY || 'BGqilq0A0d2oV1O87ZcxbFQpK1BkVaTaoVBZ34bOHBrtn0cUNzEb5rNvXYfAPa4PwUHzJGyYKVNL1ij8o5q6I5A'
        }).then((token) => {

          // actualiza fcm token si ha cambiado con el q tiene el user en DB (devices)
          if (token != data.fcm_web_token) {
            
            // Nuevo token detectado
            let url = '/api/v2/device/register'
            let postData = {
                user_id: data.user.id,
                device_type: 'Web',
                fcm_token: token
                // device_model: vm.$browserDetect.meta.name, (chrome) TO-DO. plugin vue-browser-detect-plugin
                // device_version: vm.$browserDetect.meta.version (89)
            }

            axios.post(url, postData).then(function (response) {
              if (response.data.success !== 'true' && response.data.success !== true)
                console.log('Error guardando nuevo token fcm');
            })
            
          }
        }).catch((err) => {
          console.error('Error getting FCM token:', err);
          
          // Si es un error de autenticación, mostrar mensaje más específico
          if (err.code === 'messaging/token-subscribe-failed') {
            console.error('    Error de autenticación FCM. Verifica que la VAPID key esté configurada correctamente en el archivo .env');
          }
        });
      });
    }
    else if (Notification.permission !== "denied") {
      // si no establecido, pedir permiso y empezamos de nuevo
      Notification.requestPermission().then( (permission) => this.registerFCMWebToken(data))
    }
  }
}
